import React, { FunctionComponent } from "react";
import styles from "./Video.module.scss";
import VideoProps from "./VideoProps.interface";

import VideoViewer from "components/VideoViewer/VideoViewer";
import getVideoAspectRatio from "app/media/helpers/getVideoAspectRatio";
import VideoEmbed from "components/VideoEmbed/VideoEmbed";
import combineClasses from "helpers/combine-classes";

const Video: FunctionComponent<VideoProps> = (props): JSX.Element => {
    const videoAspectRatio = getVideoAspectRatio(props.mediaCrop, "Square (1:1)");
    const videoSource = props.content?.video && props.content?.video.length > 0 ? props.content.video?.[0].content : undefined;

    return (
        <div className={combineClasses(styles.wrapper, props.className)}>
            {/* Local Video */}
            {videoSource && videoSource._contentType === "blockVideoNestedLocal" && videoSource.video?.umbracoFile ? (
                <VideoViewer src={videoSource.video?.umbracoFile} poster={videoSource.poster?.umbracoFile?.src} autoplay={true} loop={true} controls={false} aspectRatioX={videoAspectRatio.aspectRatioX} aspectRatioY={videoAspectRatio.aspectRatioY} />
            ) : null}

            {/* Video Embed */}
            {videoSource && videoSource._contentType === "blockVideoNestedYouTube" && videoSource.videoUrl ? (
                <VideoEmbed src={videoSource.videoUrl} autoplay={true} loop={true} aspectRatioX={videoAspectRatio.aspectRatioX} aspectRatioY={videoAspectRatio.aspectRatioY} />
            ) : null}
        </div>
    );
};

export default Video;